import React, { useContext, useState } from "react";
import { Formik, Field } from "formik";
import { BiHide, BiShow } from "react-icons/bi";
import {
  Box,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  InputRightElement,
  Text,
  Input,
  VStack,
  InputGroup,
  Button,
  useToast,
  Link as ChakraLink,
  useColorModeValue,
  Heading,
  Container,
  Stack,
  Icon,
  useMediaQuery
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { FaInstagram, FaTelegram, FaGoogle } from 'react-icons/fa';
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const Signup = () => {
  const [data, setData] = useState({ email: "", password: "" });
  const [pass, setPass] = useState("");
  const [show, setShow] = useState(false);
  const [isLargerThan770] = useMediaQuery("(min-width: 770px)");
  const { signInWithGoogle, signupUser } = useContext(AppContext);

  // Theme Hooks
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const inputBg = useColorModeValue("gray.50", "gray.700");
  const inputHoverBg = useColorModeValue("gray.100", "gray.600");
  const brandColor = "brand.500";
  const brandHoverColor = "brand.600";

  return (
    <Box minH="100vh" bg={bg} position="relative" overflow="hidden">
      <Helmet>
        <title>Signup | Techy India</title>
      </Helmet>

      {/* Background Blobs */}
      <Box
        position="absolute"
        top="-10%"
        right="-10%"
        w="300px"
        h="300px"
        bg={brandColor}
        filter="blur(100px)"
        opacity={0.2}
        borderRadius="full"
      />
      <Box
        position="absolute"
        bottom="-10%"
        left="-10%"
        w="300px"
        h="300px"
        bg="purple.500"
        filter="blur(100px)"
        opacity={0.2}
        borderRadius="full"
      />

      <Container maxW="lg" py={{ base: 12, md: 24 }} px={{ base: 4, sm: 8 }}>
        <Stack spacing={8}>
          <Stack align="center" spacing={2}>
            <Heading fontSize="3xl" textAlign="center" fontWeight="bold" bgGradient={`linear(to-r, ${brandColor}, purple.500)`} bgClip="text">
              Create Account
            </Heading>
            <Text fontSize="lg" color={"gray.500"}>
              Join us and start your journey
            </Text>
          </Stack>

          <Box
            as={motion.div}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            rounded="2xl"
            bg={cardBg}
            boxShadow="xl"
            border="1px solid"
            borderColor={borderColor}
            p={8}
            backdropFilter="blur(10px)"
          >
            <Stack spacing={6}>
              {/* Google Sign Up */}
              {/* <Button
                w="full"
                variant="outline"
                leftIcon={  <Image
                w={["25px", "28px"]}
                src={"https://img.icons8.com/color/452/google-logo.png"}
              />  }
                onClick={signInWithGoogle}
                h="50px"
                fontSize="md"
                borderColor={borderColor}
                _hover={{ bg: inputHoverBg }}
              >
                Sign up with Google
              </Button> */}

              <Flex align="center">
                <Box flex={1} h="1px" bg={borderColor} />
                <Text px={4} color="gray.500" fontSize="sm">
                  OR
                </Text>
                <Box flex={1} h="1px" bg={borderColor} />
              </Flex>

              <Formik
                initialValues={{ email: "", password: "" }}
                onSubmit={(values) => {
                  setData(values);
                  signupUser(values.email, values.password)
                    .then((res) => { })
                    .catch(() => { });
                }}
              >
                {({ handleSubmit, errors, touched }) => (
                  <form onSubmit={handleSubmit}>
                    <Stack spacing={4}>
                      <FormControl isInvalid={!!errors.email && touched.email}>
                        <FormLabel>Email address</FormLabel>
                        <Field
                          as={Input}
                          name="email"
                          type="email"
                          placeholder="Enter your email"
                          bg={inputBg}
                          border="none"
                          h="50px"
                          _hover={{ bg: inputHoverBg }}
                          _focus={{ bg: "transparent", borderColor: brandColor, borderWidth: "2px" }}
                          validate={(value) => {
                            let error;
                            if (!value) error = "Required";
                            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) error = "Invalid email address";
                            return error;
                          }}
                        />
                        <FormErrorMessage>{errors.email}</FormErrorMessage>
                      </FormControl>

                      <FormControl isInvalid={!!errors.password && touched.password}>
                        <FormLabel>Password</FormLabel>
                        <InputGroup>
                          <Field
                            as={Input}
                            name="password"
                            type={show ? "text" : "password"}
                            placeholder="Create a password"
                            bg={inputBg}
                            border="none"
                            h="50px"
                            _hover={{ bg: inputHoverBg }}
                            _focus={{ bg: "transparent", borderColor: brandColor, borderWidth: "2px" }}
                            validate={(value) => {
                              if (!value) return "Required";
                              if (value.length < 7) return "Password must contain at least 8 characters";
                              setPass(value);
                            }}
                          />
                          <InputRightElement h="50px">
                            <Box onClick={() => setShow(!show)} cursor="pointer" color="gray.500">
                              {show ? <BiHide size={20} /> : <BiShow size={20} />}
                            </Box>
                          </InputRightElement>
                        </InputGroup>
                        <FormErrorMessage>{errors.password}</FormErrorMessage>
                      </FormControl>

                      <FormControl isInvalid={!!errors.confirm && touched.confirm}>
                        <FormLabel>Confirm Password</FormLabel>
                        <InputGroup>
                          <Field
                            as={Input}
                            name="confirm"
                            type={show ? "text" : "password"}
                            placeholder="Confirm your password"
                            bg={inputBg}
                            border="none"
                            h="50px"
                            _hover={{ bg: inputHoverBg }}
                            _focus={{ bg: "transparent", borderColor: brandColor, borderWidth: "2px" }}
                            validate={(value) => {
                              if (!value) return "Required";
                              if (value.length > 5 && pass !== value) return "Passwords must match";
                            }}
                          />
                          <InputRightElement h="50px">
                            <Box onClick={() => setShow(!show)} cursor="pointer" color="gray.500">
                              {show ? <BiHide size={20} /> : <BiShow size={20} />}
                            </Box>
                          </InputRightElement>
                        </InputGroup>
                        <FormErrorMessage>{errors.confirm}</FormErrorMessage>
                      </FormControl>

                      <Button
                        type="submit"
                        bg={brandColor}
                        color="white"
                        size="lg"
                        fontSize="md"
                        h="50px"
                        mt={2}
                        _hover={{ bg: brandHoverColor, transform: "translateY(-2px)", boxShadow: "lg" }}
                        transition="all 0.2s"
                      >
                        Create Account
                      </Button>
                    </Stack>
                  </form>
                )}
              </Formik>

              <Stack pt={4} align="center">
                <Text fontSize="sm" color="gray.500">
                  Already have an account?{" "}
                  <Link to="/login">
                    <Text as="span" color={brandColor} fontWeight="bold" _hover={{ textDecoration: "underline" }}>
                      Login
                    </Text>
                  </Link>
                </Text>
              </Stack>
            </Stack>
            {/* Policy Links */}
            <Stack align="center" mt={'0.5rem'} spacing={1}>
              <Text fontSize="xs" color="gray.400">
                By continuing, you agree to:
              </Text>
              <Stack direction="row" spacing={2} align="center">
                <Link to="/privacy">
                  <Text fontSize="xs" color={brandColor} fontWeight="semibold" _hover={{ textDecoration: "underline" }}>Privacy</Text>
                </Link>
                <Text fontSize="xs" color="gray.400">|</Text>
                <Link to="/terms">
                  <Text fontSize="xs" color={brandColor} fontWeight="semibold" _hover={{ textDecoration: "underline" }}>Terms</Text>
                </Link>
                <Text fontSize="xs" color="gray.400">|</Text>
                <Link to="/refund-policy">
                  <Text fontSize="xs" color={brandColor} fontWeight="semibold" _hover={{ textDecoration: "underline" }}>Refund</Text>
                </Link>
              </Stack>
            </Stack>

            <Stack direction="row" mt={'1rem'} spacing={6} justify="center" w="full">
              <ChakraLink href="https://www.instagram.com/durgeshsingh__cryptotrader?igsh=MWE4YzVtN2pyMmk1ZQ%3D%3D&utm_source=qr" isExternal>
                <Icon as={FaInstagram} w={8} h={8} color="pink.500" _hover={{ transform: "scale(1.1)" }} transition="all 0.2s" />
              </ChakraLink>
              <ChakraLink href="https://t.me/techyindiaxyzofficial" isExternal>
                <Icon as={FaTelegram} w={8} h={8} color="blue.400" _hover={{ transform: "scale(1.1)" }} transition="all 0.2s" />
              </ChakraLink>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Signup;
